import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AdminDashboard from './AdminDashboard';
import AdminProducts from './AdminProducts';
import AdminProduct from './AdminProduct';
import AdminMenus from './AdminMenus';
import AdminMenu from './AdminMenu';
import AdminDishes from './AdminDishes';
import AdminDish from './AdminDish';
import AdminServicesCalendar from './AdminServicesCalendar';
import AdminServiceDishSelection from './AdminServiceDishSelection';
import AdminService from './AdminService';
import AdminClients from './AdminClients';
import AdminClient from './AdminClient';
import AdminChefs from './AdminChefs';
import AdminChef from './AdminChef';
import AdminGroceryList from './AdminGroceryList';

class AdminRouter extends React.Component {
  render() {
    const { url: baseUrl } = this.props.match;

    return (
      <div className="admin-wrapper">
        <Switch>
          <Route exact path={`${baseUrl}/`} component={AdminDashboard} />
          <Route path={`${baseUrl}/products/`} component={AdminProducts} />
          <Route path={`${baseUrl}/product/:id?`} component={AdminProduct} />
          <Route path={`${baseUrl}/menus`} component={AdminMenus} />
          <Route path={`${baseUrl}/menu/:id/:type?`} component={AdminMenu} />
          <Route path={`${baseUrl}/dishes`} component={AdminDishes} />
          <Route path={`${baseUrl}/dish/:id?`} component={AdminDish} />
          <Route path={`${baseUrl}/clients`} component={AdminClients} />
          <Route path={`${baseUrl}/client/:id`} component={AdminClient} />
          <Route path={`${baseUrl}/chefs`} component={AdminChefs} />
          <Route
            path={`${baseUrl}/chef/:id`}
            render={props => (
              <AdminChef {...props} isMobile={this.props.isMobile} />
            )}
          />
          {/* Route is not currently being used */}
          {/* <Route path={`${baseUrl}/service-list`} component={AdminServices} /> */}
          <Route
            path={`${baseUrl}/services`}
            component={AdminServicesCalendar}
          />
          <Route
            exact
            path={`${baseUrl}/service/dish-selection`}
            component={AdminServiceDishSelection}
          />
          <Route
            path={`${baseUrl}/service/:id/:type?`}
            component={AdminService}
          />
          <Route
            path={`${baseUrl}/grocery-list/:id`}
            component={AdminGroceryList}
          />
        </Switch>
      </div>
    );
  }
}
export default AdminRouter;



// WEBPACK FOOTER //
// ./src/components/admin/AdminRouter.js